import { useMemo } from 'react'
import { useFirestore } from '../firebase/useFirestore'
import groupOptionsByField from '../helpers/dataFields/groupOptionsByField'

/**
 * De antwoordopties van alle meerkeuze-gegevensvelden van deze omgeving,
 * gegroepeerd per veld.
 *
 * In één keer ophalen en hier groeperen, want Firestore kan niet per rij een
 * eigen query krijgen vanuit een lus — een hook per tabelrij bestaat niet. Het
 * gaat om een paar honderd kleine documenten per omgeving (de grootste heeft er
 * 619), dus dat weegt op tegen tientallen losse queries.
 *
 * Sorteren gebeurt client-side: een `orderBy` op `Position` naast het filter op
 * de omgeving vraagt een samengestelde index die er niet is, en zo'n mislukte
 * query is stil — het scherm toont dan gewoon 'geen opties'.
 * AI-CONTEXT: See docs/pitfalls.md#database-firestore-missing-composite-index
 *
 * Een gegevensregel die uit een intakeformulier komt zoekt zijn opties op het
 * formulierveld (`FormFieldID`); een handmatig toegevoegde regel op zijn eigen
 * `ID`. Dat is dezelfde sleutel als `MultipleQuestionOptions.Field` elders.
 *
 * AI-CONTEXT: See docs/features/gegevensveld-types.md
 *
 * @returns {{optionsFor: (item: object) => Array<object>, optionKey: (item: object) => string}}
 */
const useDataFieldOptions = () => {
    const options = useFirestore('MultipleQuestionOptions')

    const perVeld = useMemo(() => groupOptionsByField(options), [options])

    const optionKey = (item) => item?.FormFieldID || item?.ID || ''

    const optionsFor = (item) => perVeld[optionKey(item)] || []

    return { optionsFor, optionKey }
}

export default useDataFieldOptions
